import { Button } from '@simplea/shared-ui';
import { ErrorLayout as LayoutCS } from '../../components';
import { Layout as LayoutPL } from '../../components/Poland';
import rip from '../../static/images/rip.png';
import { useTranslation } from 'react-i18next';
import { Language } from '../../i18n';
import { DefaultFooter } from '../../components';

import './NotFound.styles.css';

interface NotFoundProps {
    language: string;
}

export const NotFound = ({ language }: NotFoundProps) => {
    const { t } = useTranslation();

    const LayoutComponent = language === Language.PL ? LayoutPL : LayoutCS;

    return (
        <LayoutComponent mode="error" footerContent={<DefaultFooter />}>
            <div className="container">
                <div className="not-found">
                    <div className="image">
                        <img src={rip} alt="working" width="365" data-test="notFoundImage" />
                    </div>
                    <div className="content">
                        <div className="headline" style={{ margin: 0 }} data-test="headline">
                            {t('404.headline')}
                        </div>
                        <p className="description" style={{ textAlign: 'left' }} data-test="description">
                            {t('404.description')}
                        </p>
                        <Button
                            onClick={() => window && window.open(t('marketingWebLink'), '_self')}
                            className="w-fit-content mx-auto"
                            small
                            data-test="notFoundButton"
                        >
                            {t('simpleaRedirect')}
                        </Button>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    );
};
